export const existPartnerTemplate = () => {
  try {
    let subdomain = window.location.host.split(".")[0];
    const template = require(`../templates/${subdomain}.json`);
    return template;
  } catch (error) {
    return false;
  }
};
